<h1 class="h4 text-center custom-header w-100 mt-3 mb-0" *ngIf="mapTitle?.DisplayName || mapTitle?.Title">{{
  mapTitle?.DisplayName || mapTitle?.Title
  }}</h1>

<h1 class="text-center w-100 mb-3" aria-label="Map">Map</h1>

<div class="filter-panel" *ngIf="isFiltersAllowed" [ngStyle]="{
  'top': mapBox.offsetTop +20+'px',
  'left':mapBox.offsetLeft + 10+'px',
  'backgroundColor': isFilterActive ? 'white':''
}">
  <button *ngIf="!isFilterActive" (click)="isFilterActive = !isFilterActive" class="border rounded-circle filter-icon-map" 
    type="button"
    [attr.aria-label]="'Filter map data. Press Enter or Space to open filters'"
    [attr.aria-expanded]="isFilterActive"
    (keydown.enter)="isFilterActive = !isFilterActive"
    (keydown.space)="$event.preventDefault(); isFilterActive = !isFilterActive">
    <i class="icon-filter-list" aria-hidden="true"></i>
  </button>
  <dialog [ngStyle]=" { 'height':mapBox.offsetHeight-20+'px','display': isFilterActive ?'':'none'}" style="width: 375px;" class="filter-box" [attr.aria-label]="'Map filters'" [open]="isFilterActive">
    <app-filter-map
      [isMapInteractive]="isMapInteractive"
      [filterFieldOptions]="filterFieldOptions"
      [mapReportData]="mapReportData"
      [isEmbeddedReport]="isEmbeddedReport"
      [seriesData]="seriesData"
      [geoJSONData]="geoJSONData"
      [tableId]="tableId"
      [reportId]="reportId"
      [fromDashboard]="fromDashboard"
      [totalRecords]="totalDataLength"
      [filteredRecord]="displayingData"
      [isLimitExceed]="isLimitExceed"
      [referenceFieldKey]="referenceFieldKey"
      [lookupfield]="lookupfield"
      [markerColorField]="markerColorField"
      [enableAccessibility]="enableMapAccessibilityValue"
      (disableFilter)="disableFilterPanel()"
      (applyLayer)="applyLayerOnMap($event)"
      (resetMapData)="resetMap()"
    ></app-filter-map>
  </dialog>
</div>
<section #mapBox [ngStyle]="{ 'width': isMapInteractive && mapReportData?.BoundaryQueryField ? '64%':'', 'display': isMapInteractive && mapReportData?.BoundaryQueryField ? 'inline-block':''}" aria-label="Interactive map">
  <mgl-map [style]="'mapbox://styles/mapbox/streets-v9'" [zoom]="zoom" [center]="center" *ngIf="!isUserUnAuthorized"
    (render)="onRender($event)" #mapContainer aria-label="Map view">
    <ng-container *ngIf="enableMapAccessibility$ | async">
      <mgl-popup *ngIf="popupData.coordinates" [anchor]="popupAnchor" [focusAfterOpen]="true" [lngLat]="popupData.coordinates" [closeOnClick]="false"
        [closeButton]="false" [offset]="popupOffSet" [className]="'custom-marker-popup'" aria-live="polite" aria-label="Location details">
        <h2 style="width: fit-content;" [attr.aria-label]="'Location details for ' + popupData.name"><strong>{{mapReportData?.NameField ? mapReportData?.NameField?.Name : 'Name'}}</strong>: {{ popupData.name }} </h2>
        <p><strong>{{ mapReportData?.DescriptionField ? mapReportData?.DescriptionField?.Name:"Description" }}</strong>: {{ popupData.description }}</p>
        <p><strong>{{ mapReportData?.PrimaryDescriptionField ? mapReportData?.PrimaryDescriptionField?.Name:"Primary Description" }}</strong>: {{ popupData.primaryDescription }}</p>
        <p><strong>{{ mapReportData?.SecondaryDescriptionField ? mapReportData?.SecondaryDescriptionField?.Name:"Secondary Description" }}</strong>: {{ popupData.secondaryDescription }}</p>
        <p><strong>Record Id</strong>: {{ popupData.id }}</p>
      </mgl-popup>
    </ng-container>
    <ng-container *ngIf="!(enableMapAccessibility$ | async)">
      <mgl-popup *ngIf="popupData.coordinates" [anchor]="popupAnchor" [focusAfterOpen]="true" [lngLat]="popupData.coordinates" [closeOnClick]="false"
        [closeButton]="false" [offset]="popupOffSet" [className]="'custom-marker-popup'">
        <h2 style="width: fit-content;"><strong>{{mapReportData?.NameField ? mapReportData?.NameField?.Name : 'Name'}}</strong>: {{ popupData.name }} </h2>
        <p><strong>{{ mapReportData?.DescriptionField ? mapReportData?.DescriptionField?.Name:"Description" }}</strong>: {{ popupData.description }}</p>
        <p><strong>{{ mapReportData?.PrimaryDescriptionField ? mapReportData?.PrimaryDescriptionField?.Name:"Primary Description" }}</strong>: {{ popupData.primaryDescription }}</p>
        <p><strong>{{ mapReportData?.SecondaryDescriptionField ? mapReportData?.SecondaryDescriptionField?.Name:"Secondary Description" }}</strong>: {{ popupData.secondaryDescription }}</p>
        <p><strong>Record Id</strong>: {{ popupData.id }}</p>
      </mgl-popup>
    </ng-container>
    <ng-container *ngIf="locations">
      <mgl-geojson-source #clusterComponent id="loc" [data]="locations" [cluster]="true" [clusterRadius]="30"
        [clusterMaxZoom]="14"></mgl-geojson-source>
      <mgl-markers-for-clusters source="loc">
        <ng-container *ngIf="enableMapAccessibility$ | async">
          <ng-template mglPoint let-feature>
            <button class="marker" (mouseover)="mouseIn(feature.properties)" (mouseout)="mouseOutFromPoint()"
              (click)="editLocation($event,feature)" 
              (focus)="mouseIn(feature.properties)"
              (blur)="mouseOutFromPoint()"
              id="marker-{{ feature.properties.Id}}"
              type="button"
              [attr.aria-label]="'View ' + (feature.properties.Name || feature.properties.Description || 'location details')">
              <img [src]="marker" *ngIf="!isCustomColor" [attr.alt]="'Map marker for ' + (feature.properties.Name || 'location')" srcset="" />
              <i class="icon-location" *ngIf="isCustomColor" style="font-size: 30px;" [ngStyle]="{'color' : getColorForValue(!isMapInteractive ? feature.properties.SeriesField1 : feature.properties.MarkerColorField)}" aria-hidden="true"></i>
            </button>
          </ng-template>
          <ng-template mglClusterPoint let-feature>
            <button class="marker-cluster" type="button" [attr.aria-label]="'Cluster of ' + feature.properties?.point_count + ' locations'">
              {{ feature.properties?.point_count }}
            </button>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="!(enableMapAccessibility$ | async)">
          <ng-template mglPoint let-feature>
            <div class="marker" (mouseover)="mouseIn(feature.properties)" (mouseout)="mouseOutFromPoint()"
              (click)="editLocation($event,feature)" id="marker-{{ feature.properties.Id}}">
              <img [src]="marker" *ngIf="!isCustomColor" alt="" srcset="" />
              <i class="icon-location" *ngIf="isCustomColor" style="font-size: 30px;" [ngStyle]="{'color' : getColorForValue(!isMapInteractive ? feature.properties.SeriesField1 : feature.properties.MarkerColorField)}"></i>
            </div>
          </ng-template>
          <ng-template mglClusterPoint let-feature>
            <div class="marker-cluster">
              {{ feature.properties?.point_count }}
            </div>
          </ng-template>
        </ng-container>
      </mgl-markers-for-clusters>
    </ng-container>
  </mgl-map>

  <div *ngIf="isUserUnAuthorized">User is not authorized to see this report</div>

</section>
<aside class="sliding-panel" *ngIf="showPanel" [ngStyle]="{ 
  'top': mapBox.offsetTop +60+'px',
  'left':showPanel ? mapBox.offsetWidth - 410 +'px' :''
}" aria-label="Location details panel">
  <div class="panel-content" #modalContent>
    <app-upsert-location [tableId]="tableId" [reportsData]="reportsData" [pinId]="featureProperties.Id"
      [inputProp]="featureProperties" [mapReportData]="mapReportData" [isLimitExceed]="isLimitExceed" [isCustomColor]="isCustomColor" [marker]="marker" [iconColor]="getColorForValue(!isMapInteractive ? featureProperties.SeriesField1 : featureProperties.MarkerColorField)" (closeModal)="closeMarkerDetails()"></app-upsert-location>
  </div>
</aside>

<section *ngIf="isMapInteractive && mapReportData?.BoundaryQueryField" [ngStyle]="{ 'width': isMapInteractive ? '33%':'' , 'display': isMapInteractive ? 'inline-flex':''}" style="margin-left: 25px; flex-direction: column; position: absolute;" aria-label="Map data table">
  <button class="btn btn-primary ml-auto" type="button" *ngIf="isLayerClicked" (click)="resetLayerClick()" aria-label="Reset layer selection and show all data">Reset Selection</button>
<app-ngx-datatable 
    [dataset]="mapDataSet"
    [columns]="mapColumns"
    [trigger]="mapTrigger"
    [externalSorting]="false"
    [externalPaging]="true"
    [showEnteriesDropdown]="true"
    [isBulkDeleteEnable]="false"
    [isBulkUpdateEnable]="false"
    [isLightHeader]="true"
    [hideGrouping]="true"
    [showExport]="false"
    [fromMapInDashboard]="true"
    [fromRecordTable]="true"
    (payload)="payloadListener($event)"
    [enableSummaryRow]="true"
    [summaryFunction]="mapReportData?.SummaryType"
  ></app-ngx-datatable>
</section>
